import { Injectable } from '@angular/core';

import { OfferSource } from '@cds';
import { DetailedFixtureFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { OfferGroupingService } from '@frontend/sports/betting-offer/feature/offer-grouping';
import { ConnectionConfig } from '@frontend/sports/common/client-config-data-access';
import {
    CdsPushService,
    CdsSubscription,
    FixtureSlimSubscription,
    GameSubscription,
    OptionMarketSubscription,
} from '@frontend/sports/content-distribution/feature';
import { MessageCallback } from '@frontend/sports/event-subscription/feature/base-subscription';
import { DetailedEventSubscriptionService } from '@frontend/sports/event-subscription/feature/detailed-event-subscription';

/**
 * Expects detailed event, subscribes to only the provided markets without scoreboard
 *
 * @export
 * @class TopEventsSubscriptionService
 * @extends {DetailedEventSubscriptionService}
 */
@Injectable({ providedIn: 'root' })
export class TopEventsSubscriptionService extends DetailedEventSubscriptionService {
    constructor(fixtureFactory: DetailedFixtureFactory, push: CdsPushService, connection: ConnectionConfig, groupingService: OfferGroupingService) {
        super(fixtureFactory, push, connection, groupingService);
    }

    protected override getContextSubscriptions(event: EventModel, callback: MessageCallback): CdsSubscription[] {
        const subscriptions = [
            new FixtureSlimSubscription(event.offerContext, event.id, this.connection.culture, callback),
            ...event.optionGroups.map((og) =>
                event.offerSource === OfferSource.V2
                    ? new OptionMarketSubscription(event.offerContext, event.id, og.id, this.connection.culture, callback)
                    : event.hybridFixtureData
                      ? new OptionMarketSubscription(event.offerContext, event.id, og.id, this.connection.culture, callback)
                      : new GameSubscription(event.offerContext, event.id, og.id, this.connection.culture, callback),
            ),
        ];

        return subscriptions;
    }
}
